module.exports = __webpack_public_path__ + "img/newslist-广告图-972x90.968a04da.jpg";